// 配置首页接口
import request from "../../../util/request"

export default class ReportApi {
    // 查看报告
    async getReport(phone, idCard) {
        const res = await request.post('/apis/order/report', { phone: phone, idCard: idCard })
        return res.data;
    }
}
